





















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

// Model
import UserModel from '@/_models/UserModel'

// Interfaces
import { IDropdownList } from '@/_interfaces'

// Components
import TablePagination from '@/components/shared/TablePagination.vue'
import DropdownSearch from '@/components/common/buttons/DropdownSearch.vue'

@Component({
  components: { TablePagination, DropdownSearch },
})
export default class SearchUser extends Vue {
  // Props
  @Prop()
  selectedData!: any

  currentPage: number = 1
  perPage: number = 10
  numofPage: number = 1
  selected: any = {}
  isFormModalActive: boolean = false

  searchQuery: string = ''
  selectedFilter: string = 'name'
  filedNameLUT: any = {
    _id: 'UUID',
    user_id: 'label.user_id',
    name: 'label.username',
    category_name: 'label.category',
    san_id: 'label.card_number',
  }

  dropdownList: IDropdownList[] = [
    {
      value: 'name',
      label: this.$t('label.username').toString(),
    },
    {
      value: 'category_name',
      label: this.$t('label.category').toString(),
    },
    {
      value: 'san_id',
      label: this.$t('label.card_number').toString(),
    },
  ]

  // computed
  get users(): UserModel[] {
    const users = this.$store.state.users.all.items
    this.numofPage = Math.ceil(users.length / this.perPage)

    return users
  }

  get isLoading(): boolean {
    return this.$store.state.users.loading
  }

  get disabledSelectRow(): any {
    return (row): boolean => {
      return (
        (row.card_id && row.card_id !== '' && row._id !== this.selectedData._id) ||
        (row.beacon_id && row.beacon_id !== '' && row._id !== this.selectedData._id)
      )
    }
  }

  get filteredData(): UserModel[] {
    const targetField: string = this.selectedFilter
    if (!this.users) {
      return []
    }

    return this.users.filter((item: any): boolean => {
      return String(item[targetField]).toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1
    })
  }

  @Watch('selected')
  async selectedChanged() {
    if (!this.selected._id) {
      return
    }

    if (this.disabledSelectRow(this.selected)) {
      this.resetSelected()
    }
  }

  // methods
  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  handleSelectFinished(): void {
    const selectedData = {
      _id: this.selected._id || '',
      name: this.selected.name || '',
      category_name: this.selected.category_name || '',
    }

    this.$emit('selectedUserDone', selectedData)
  }

  resetSelected(): void {
    this.selected = {}
  }

  handleToggleSelected(): void {
    if (this.selected._id) {
      this.resetSelected()
    }
  }

  // After page created
  created() {
    this.$store.dispatch('users/getAll').then(() => {
      for (const item of this.filteredData) {
        if (
          typeof this.selectedData !== 'undefined' &&
          this.selectedData &&
          item._id === this.selectedData._id
        ) {
          this.selected = item
          return
        }
      }
    })
  }
}
